export default {
        PhoneNumber: "",
        DateOfBirth: "",
        isInsurance: false,
        BSWStoreNumber: "",
        ExternalPharmacyDetail: {
            Address: "",
            Name: "",
            PhoneNumber: ""
        },
        InsuranceDetail: {
            InsuranceGroupId: "",
            InsuranceName: "",
            MemberNumber: "",
            RxBIN: "",
            RxPCNNumber: ""
        },
        PrescriptionInfo: []
};